import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Point } from 'chart.js';
import Chart from 'chart.js/auto';

@Component({
    selector: 'app-horizontal-bar-chart',
    templateUrl: './horizontal-bar-chart.component.html',
    styleUrls: ['./horizontal-bar-chart.component.scss']
})
export class HorizontalBarChartComponent implements OnInit, AfterViewInit {
    @ViewChild('chart')
    private chartRef: ElementRef;
    private chart: Chart;
    private data: Point[];

    @Input() datasets: any = null;
    @Input() labels: any = null;
    @Input() options: any = null;

    constructor() {}

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        this.chart = new Chart(this.chartRef.nativeElement, {
            type: 'bar',
            data: { datasets: this.datasets, labels: this.labels },
            options: this.options
        });
    }
}
